import type { FC } from 'react';

import { isExperimentUrl } from './utils/experiment-url';
import CheckoutAboutYou from './pages/sales-flow/checkout-about-you/checkout-about-you';
import CheckoutMembership from './pages/sales-flow/checkout-membership/checkout-membership';
import CheckoutPayment from './pages/sales-flow/checkout-payment/checkout-payment';
import CheckoutSelectClub from './pages/sales-flow/checkout-select-club/checkout-select-club';
import CheckoutStatus from './pages/sales-flow/checkout-status/checkout-status';

const experimentPageComponents: Record<string, FC> = {
  CheckoutAboutYou,
  CheckoutMembership,
  CheckoutPayment,
  CheckoutSelectClub,
  CheckoutStatus,
};

export const getExperimentPageComponent = (
  componentName: string,
  url: string | undefined,
) => {
  if (!isExperimentUrl(url) || !(componentName in experimentPageComponents)) {
    return undefined;
  }

  return experimentPageComponents[componentName];
};
